module.exports = __webpack_public_path__ + "media/images/front/team/oscar_alvarez-aaf3dd93228dfd7ce59837e9e682a160.jpg";